"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import {
  hero, executiveSummary, problem, solution, capabilityOverview,
  howItWorks, coreFeatures, advancedFeatures, useCases, benefits,
  usps, whoItsFor, whyChooseUs, relatedCapabilities, faq, paa, cta,
} from "@/lib/data/capabilities-reputation-management";

export function ReputationManagementPage() {
  return (
    <CapabilityPage
      data={{
        hero, executiveSummary, problem, solution, capabilityOverview,
        howItWorks, coreFeatures, advancedFeatures, useCases, benefits,
        usps, whoItsFor, whyChooseUs, related: relatedCapabilities, faq, paa, cta,
      }}
    />
  );
}
